import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    user: null,
    role: [],
    token: null,
    isAuthenticated: false,
    companyId: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setLogin: (state, action) => {
            state.user = action.payload.user;
            state.role = action.payload.role;
            state.token = action.payload.token;
            state.companyId = action.payload.companyId;
            state.isAuthenticated = true;
        },
        setLogout: (state) => {
            state.user = null;
            state.role = null;
            state.token = null;
            state.companyId = null;
            state.isAuthenticated = false;
        },
    },
});

export const { setLogin, setLogout } = authSlice.actions;

export default authSlice.reducer;